import React, { SVGAttributes } from 'react'

export const QRIcon: React.FC<SVGAttributes<SVGSVGElement>> = (props) => (
  <svg width="33" height="32" viewBox="0 0 33 32" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path d="M21.8333 22.6667V21.3333H17.8333V17.3333H21.8333V20H24.5V22.6667H23.1667V25.3333H20.5V28H17.8333V24H20.5V22.6667H21.8333ZM28.5 28H23.1667V25.3333H25.8333V22.6667H28.5V28ZM4.5 4H15.1667V14.6667H4.5V4ZM7.16667 6.66667V12H12.5V6.66667H7.16667ZM17.8333 4H28.5V14.6667H17.8333V4ZM20.5 6.66667V12H25.8333V6.66667H20.5ZM4.5 17.3333H15.1667V28H4.5V17.3333ZM7.16667 20V25.3333H12.5V20H7.16667ZM24.5 17.3333H28.5V20H24.5V17.3333ZM8.5 8H11.1667V10.6667H8.5V8ZM8.5 21.3333H11.1667V24H8.5V21.3333ZM21.8333 8H24.5V10.6667H21.8333V8Z" fill="white" />
  </svg>

)
